import { Injectable } from '@angular/core';

import {
  Configuration, Plan, PlanningProfile,
  RecipeRequest,
  ServerResponse,
  UserProfile,
  UserProfileRequest,
} from '../models';
import { AccountService } from './account.service';
import { AppConfig } from './app.config';
import { RestService } from './rest.service';
import {PlanningService} from './planning.service';

@Injectable()
export class ProfileService {
    constructor(
      private restService: RestService,
      private accountService: AccountService,
      private planningService: PlanningService,
    ) {
        this.Config = AppConfig.config;
        this.accountService.getLogOutSubscribtion().subscribe(result => {
            if (!result) {
                return;
            }
            this.profiles = null;
            this.proflePromise = null;
            this.updateShowCal();
        });
    }

    private Config: Configuration;
    private profiles: UserProfile[];
    private proflePromise: Promise<UserProfile[]>;
    public isShowCal = 0;
    planningProfiles: PlanningProfile[] = [];

    public get(): Promise<UserProfile[]> {
        if (this.proflePromise) {
            return this.proflePromise;
        }
        this.proflePromise = new Promise<UserProfile[]>(resolve => {
            if (this.profiles) {
                resolve(this.profiles);
            }
            const promises: Promise<any>[] = [];
            this.accountService.getCredentialsPromise().then(cred => {

                Promise.all(promises).then(() => {
                    const request = new RecipeRequest();
                    request.Id_Session = cred.Id_Session;
                    request.Page = 1;
                    request.PageSize = 100;
                    request.ApiVersion = 'v1';
                    request.Id_app = this.Config.AppId;
                    request.Controller0 = 'User';
                    request.EntityId0 = cred.Id_User;
                    request.Id_user = cred.Id_User;
                    request.Section = 'Profile';
                    request.Method = 'Print';

                    this.restService.get(request).then(x => {
                        if (x !== null) {
                            const response: ServerResponse<UserProfile> = x;
                            this.profiles = response.Result.Resultset;
                            this.updateShowCal();
                            resolve(this.profiles);
                        }
                    });
                });
            });
        });
        return this.proflePromise;
    }

    public update(profile: UserProfile) {
        return new Promise<ServerResponse<null>>(resolve => {
            this.accountService.getCredentialsPromise().then(cred => {
                const request = new UserProfileRequest();
                request.Id_session = cred.Id_Session;
                request.Page = 1;
                request.PageSize = 100;
                request.ApiVersion = 'v1';
                request.Id_app = this.Config.AppId;
                request.Controller0 = 'User';
                request.Controller1 = 'Profile';
                request.EntityId1 = profile.Id_Profile;
                request.Method = 'Update';

                request.FullName = profile.FullName;
                request.Description = profile.Description;
                request.IsShowCal = profile.IsShowCal;
                request.IsCalcCal = profile.IsCalcCal;
                request.CalorificValuePerDay = profile.CalorificValuePerDay;
                request.ProteinsPerDay = profile.ProteinsPerDay;
                request.FatsPerDay = profile.FatsPerDay;
                request.CarbohydratesPerDay = profile.CarbohydratesPerDay;
                request.PortionWeight = profile.PortionWeight;

                this.restService.post(request).then(x => {
                    if (x !== null) {
                        const response: ServerResponse<null> = x;
                        this.profiles = null;
                        this.proflePromise = null;
                        resolve(response);
                    }
                });
            });
        });
    }

    private updateShowCal(): void {
        if (!this.profiles) {
            this.isShowCal = 0;
            return;
        }

        let showCal = false;
        this.profiles.map(profile => {
            if (profile.IsShowCal == 1) {
                showCal = true;
                return;
            }
        });
        this.isShowCal = showCal ? 1 : 0;
    }

  getProfilesAndPlans(weekNumber: number): Promise<Plan[]> {
    return new Promise<Plan[]>(resolve => {
      this.accountService.getUserProfiles().then(x => {
        if (x !== null) {
          this.planningProfiles = [];
          x.forEach(profile => {
            const planningProfile = PlanningProfile.convertFromProfile(profile);
            this.planningProfiles.push(planningProfile);
          });
          this.planningProfiles = this.planningProfiles.sort((a, b) => a.Id - b.Id);
          this.planningService.getPlans(weekNumber).then(plans => {
            resolve(plans);
          });
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/profile.service.ts